"use client";

import React from "react";

import classNames from "classnames";

import { Card } from "@/components/flowbite/card";
import Typography from "@/components/flowbite/typography/typography";
import { formatNumber } from "@/shared/utils/format-number.util";

export interface ClusterSummaryMetricCardProps {
  value: number;
  label: string;
  icon: React.ReactNode;
  className?: string;
}

const ClusterSummaryMetricCardComponent: React.FC<ClusterSummaryMetricCardProps> = ({
  value,
  label,
  icon,
  className,
}) => {
  return (
    <Card className={classNames("flex flex-col gap-2 border-none bg-gray-100 p-2", className)}>
      <div className="flex gap-2">
        <Typography.H5
          className="flex-1"
          colorShade={500}
        >
          {formatNumber(value)}
        </Typography.H5>
        {icon}
      </div>
      <div>
        <Typography.BodySRegular colorShade={400}>{label}</Typography.BodySRegular>
      </div>
    </Card>
  );
};

export const ClusterSummaryMetricCard = React.memo(ClusterSummaryMetricCardComponent);
